import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import MASpinner from '../common/MASpinner';
import EditableCcsdCodeNote from '../ccsdCodeCost/EditableCcsdCodeNote';

class DefaultCcsdCodeNoteTable extends React.Component {
  getRelevantDefaultCcsdCodeCost(healthInsurer) {
    const { ccsdCode } = this.props;
    const relevantCcsdCodeCost = ccsdCode.defaultCcsdCodeCosts.find((ccsdCodeCost) => {
      return ccsdCodeCost.healthInsurer.id === healthInsurer.id;
    });
    return relevantCcsdCodeCost
      ? relevantCcsdCodeCost
      : {
          id: false,
          healthInsurer: {
            feeAssured: false,
          },
          currentCosts: [
            {
              cost: false,
              validFrom: new Date(),
            },
          ],
        };
  }

  render() {
    const { ccsdCode, healthInsurers = [], consultantTypes = [] } = this.props;
    if (!consultantTypes.length) {
      return <MASpinner />;
    }

    return (
      <div className="crud__section mb-3">
        <div className="crud__section-icon">
          <i className="fas fa-coins" />
        </div>
        <h2 className="crud__section-header">CCSD Code Insurer Note</h2>
        <Table hover bordered responsive className="consultant-ccsd-table default-ccsd-table mb-0">
          <thead>
            <tr>
              <th>Insurer</th>
            </tr>
          </thead>
          <tbody>
            {healthInsurers
              .filter((healthInsurer) => !healthInsurer.isAnalogue)
              .map((healthInsurer) => (
                <tr key={healthInsurer.id}>
                  <EditableCcsdCodeNote
                    key={`${ccsdCode.id}-${healthInsurer.id}`}
                    ccsdCode={ccsdCode}
                    defaultCcsdCodeCost={this.getRelevantDefaultCcsdCodeCost(healthInsurer)}
                    healthInsurer={healthInsurer}
                    isDefault={true}
                  />
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default DefaultCcsdCodeNoteTable;

DefaultCcsdCodeNoteTable.propTypes = {
  healthInsurers: PropTypes.array.isRequired,
  ccsdCode: PropTypes.object.isRequired,
};
